import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-financial-parameter-modal',
  templateUrl: './financial-parameter-modal.component.html',
  styleUrls: ['./financial-parameter-modal.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class FinancialParameterModalComponent {
  @Input() showModal: boolean = false;
  @Input() selectedParam: any;
  @Input() newValue: number | null = null;
  @Input() errorMessage: string = '';
  @Output() close = new EventEmitter<void>();
  @Output() saveValue = new EventEmitter<void>();
  @Output() valueChange = new EventEmitter<number | null>();

  closeModal() {
    this.close.emit();
  }

  save() {
    this.saveValue.emit();
  }

  onValueChange(val: any) {
    const num = val === '' || val === null ? null : Number(val);
    this.valueChange.emit(num);
  }
}
